"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordToggle = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var reactstrap_1 = require("reactstrap");
var icons_1 = require("../icons");
var PasswordToggle = function (_a) {
    var disabled = _a.disabled, size = _a.size, props = __rest(_a, ["disabled", "size"]);
    var _b = (0, react_1.useState)(false), visible = _b[0], setVisible = _b[1];
    var toggle = function () { return setVisible(!visible); };
    var isVisible = visible && !disabled;
    return ((0, jsx_runtime_1.jsxs)(reactstrap_1.InputGroup, __assign({ className: "input-group-merge", size: size }, { children: [(0, jsx_runtime_1.jsx)(reactstrap_1.Input, __assign({}, props, { disabled: disabled, type: isVisible ? 'text' : 'password', className: "form-control-appended" })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "input-group-append" }, { children: (0, jsx_runtime_1.jsx)(reactstrap_1.InputGroupText, __assign({ tag: "button", onClick: toggle, disabled: disabled }, { children: size === 'lg' ? (isVisible ? ((0, jsx_runtime_1.jsx)(icons_1.PreviewHide32, {})) : ((0, jsx_runtime_1.jsx)(icons_1.Preview32, {}))) : isVisible ? ((0, jsx_runtime_1.jsx)(icons_1.PreviewHide24, {})) : ((0, jsx_runtime_1.jsx)(icons_1.Preview24, {})) })) }))] })));
};
exports.PasswordToggle = PasswordToggle;
